import NavBar from './features/NavBar/NavBar'
import EmptyKegReport from './features/EmptyKegReport/EmptyKegReport'
import Footer from './features/Footer/Footer'
import beerKegOutline from './images/svg/beer-keg-outline-staggered-30-x-40.svg'

import './app.css'

export default function App() {
  return (
    <div
      // overflow-x-hidden is necessary to hide the left/right-sliding page
      // animations when the user changes pages.
      className="scrollbar-shift-fix"
    >
      <div
        className="bg-repeat bg-top min-h-screen bg-app-bg dark:bg-app-bg-dark transition-colors"
        style={{backgroundImage: `url(${beerKegOutline})`}}
      >
        <NavBar />
        <div
          className={[
            'dark:bg-app-panel-dark text-app-text dark:text-app-text-dark',
            'max-w-md my-0 mx-auto overflow-x-hidden bg-app-panel',
            'shadow-md border-x border-app-border dark:border-app-border-dark transition-colors',
          ].join(' ')}
        >
          <EmptyKegReport />
        </div>
        <Footer />
      </div>
    </div>
  )
}
